import manage from "Items/Manage";

const module = { ...manage }; // fork the module so there's 2 instances

export default module;
